import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

// Below this the shrunk viewport is just browser chrome collapsing, not a keyboard.
const KEYBOARD_THRESHOLD = 80

export default class ModalController extends Controller {
  connect () {
    this.closeOnBackdropClick = this.#closeOnBackdropClick.bind(this)
    this.handleClose = this.#handleClose.bind(this)
    this.trackKeyboard = this.#trackKeyboard.bind(this)

    this.element.addEventListener('click', this.closeOnBackdropClick)
    this.element.addEventListener('close', this.handleClose)
    window.visualViewport?.addEventListener('resize', this.trackKeyboard)
    window.visualViewport?.addEventListener('scroll', this.trackKeyboard)

    this.element.showModal()
    document.body.classList.add('body-overflow')
  }

  disconnect () {
    this.element.removeEventListener('click', this.closeOnBackdropClick)
    this.element.removeEventListener('close', this.handleClose)
    window.visualViewport?.removeEventListener('resize', this.trackKeyboard)
    window.visualViewport?.removeEventListener('scroll', this.trackKeyboard)
    this.close()
  }

  show () {
    this.element.showModal()
    document.body.classList.add('body-overflow')
  }

  close () {
    try {
      this.element.close()
    } catch (e) {}
  }

  #closeOnBackdropClick (event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  // The dialog sits in the top layer, i.e. it is positioned against the layout
  // viewport, which the virtual keyboard does not shrink. Without this the sticky
  // footer (and its submit button) ends up hidden behind the keyboard on mobile.
  #trackKeyboard () {
    const viewport = window.visualViewport
    const inset = window.innerHeight - viewport.height - viewport.offsetTop

    if (inset > KEYBOARD_THRESHOLD) {
      this.element.style.setProperty('--modal-keyboard-inset', `${Math.round(inset)}px`)
      this.element.style.setProperty('--modal-max-height', `${Math.round(viewport.height * 0.95)}px`)

      const focused = document.activeElement
      if (focused && this.element.contains(focused)) {
        focused.scrollIntoView({ block: 'center', behavior: 'smooth' })
      }
    } else {
      this.element.style.removeProperty('--modal-keyboard-inset')
      this.element.style.removeProperty('--modal-max-height')
    }
  }

  #handleClose () {
    document.body.classList.remove('body-overflow')
    ModalController.turboFrame.src = null
    this.element.remove()
  }

  static get turboFrame () {
    return document.querySelector('turbo-frame[id=\'modal\']')
  }
}

stimulus.register('modal', ModalController)
